import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  requiredRole?: string;
  component: React.ComponentType<any>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredRole,
  component: Component
}) => {
  const { isAuthenticated, user, loading } = useAuth();
  
  // Debug logging
  console.log('ProtectedRoute - isAuthenticated:', isAuthenticated);
  console.log('ProtectedRoute - user:', user);
  console.log('ProtectedRoute - requiredRole:', requiredRole);
  console.log('ProtectedRoute - user role:', user?.role);
  console.log('ProtectedRoute - role match:', user?.role === requiredRole);
  
  // Check if this is a Netlify deployment
  const isNetlifyDeployment = 
    window.location.hostname.includes('netlify.app') || 
    window.location.hostname.includes('github.io') ||
    window.location.hostname.includes('reporting.roiconstruction.com') ||
    process.env.REACT_APP_USE_MOCK_DATA === 'true' ||
    process.env.REACT_APP_NETLIFY === 'true';

  // Show loading indicator while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // For Netlify deployments, allow access even if not authenticated
  if (!isAuthenticated && !isNetlifyDeployment) {
    return <Navigate to="/login" replace />;
  }

  // Check for required role if specified (skip for Netlify deployments)
  if (requiredRole && user?.role !== requiredRole && !isNetlifyDeployment) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Render the specified component
  return <Component />;
};

export default ProtectedRoute;